<script>
    let imageSection;
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Questions');
    /**
     */
    function onStart() {
        imageSection.style.left = '50vw';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowLeft') {
            goto('/joinus');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section>
    <div class="main-div">
        <div class="textsection">
            <div class="textdiv">
                <p>
                    Q&A
                </p>
            </div>
            <div class="sign">
                <img
                    src="../images/moat/zigzag_31.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
       
        <div class="image-section" bind:this={imageSection}>
            <div class="img">
                <img
                    src="../images/moat/Group 1410091638.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="txt">
                <p>#CATPEOPLE</p>
                <br>
                <p>#PAW-SIBBLE</p>
                <br>
                <p>#PURR-CEPTION</p>
            </div>
        </div>
    </div>
</section>

<style>
    p{
        margin: 0;
    }
    .main-div {
        position: relative;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-color: #ffcc33;
    }
    .textsection{
        position: absolute;
        left: 17vw;
        top: 35vh;
    }
    .textdiv{
        font-size: 7.813vw;
        color: #010422;
        font-weight: 900;
    }
    .sign {
        width: 12.535vw;
        margin-left: 4vw;
    }
    .img {
        width: 36.458vw;
        height: 36.458vw;
    }
    .txt {
        font-family: "Montserrat";
        font-weight: 900;
        font-size: 1.042vw;
        color: black;
        line-height: 1.042vh;
        margin-left: 22vw
    }
    .image-section {
        position: absolute;
        left: 100vw;
        top: 5.704vh;
        transition-duration: 1s;
    }
</style>
